// `useRankings` — TanStack Query hook for /api/rankings.
//
// FILT-04 mitigation: passes `signal` from queryFnContext so React Query
// auto-aborts in-flight fetches when the query key changes (e.g. user drags
// the radius slider). Stale responses can never overwrite fresh ones.
//
// Pitfall 14: staleTime 30s prevents StrictMode double-mount from doubling
// the request rate. Inherits the global queryClient default but is explicit
// here for read-site clarity.

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { FilterState, RankedPropertyDTO } from '@/types/db';
import { fetchRankings } from '@/lib/api';

export function useRankings(filters: FilterState): UseQueryResult<RankedPropertyDTO[], Error> {
  return useQuery<RankedPropertyDTO[], Error>({
    // queryKey is structurally compared by React Query — every distinct
    // FilterState combo gets its own cache entry; identical filters dedupe.
    queryKey: ['rankings', filters],
    queryFn: ({ signal }) => fetchRankings(filters, signal),
    staleTime: 30_000,
  });
}
